import axios from "axios";
import {
  clearAuthorizationCache,
  loadAuthorization,
} from "auth/authorization.service";

const API_URL = `${process.env.REACT_APP_API_URL}/api/Auth/login`;
const REGISTER_URL = `${process.env.REACT_APP_API_URL}/api/Auth/register`;

export const loginService = async (username, password, rememberMe) => {
  const response = await axios.post(API_URL, {
    userName: username,
    password: password,
    rememberMe: rememberMe,
  });

  const { token, userId, userName, fullName, email, role, avatarFilePath } =
    response.data;
  if (token) {
    const userData = JSON.stringify({
      userId,
      userName,
      fullName,
      email,
      role,
      avatarFilePath,
    });

    // Xóa token và user data từ cả localStorage và sessionStorage trước
    logoutService();

    // Lưu vào storage phù hợp
    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem("token", token);
    storage.setItem("user", userData);

    try {
      await loadAuthorization({ force: true });
    } catch (error) {
      clearAuthorizationCache();
      console.warn("Unable to load authorization after login:", error);
    }

    // Fire storage event manually vì localStorage.setItem không trigger event trong cùng tab
    window.dispatchEvent(
      new StorageEvent("storage", {
        key: "token",
        newValue: token,
        storageArea: storage,
      })
    );
  }
  return response.data;
};

export const register = async (registerData) => {
  const response = await axios.post(REGISTER_URL, registerData);
  return response.data;
};

export const logoutService = () => {
  clearAuthorizationCache();
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
};

export const getToken = () => {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
};

export const getUser = () => {
  const user = localStorage.getItem("user") || sessionStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const updateUser = (userData) => {
  // Tìm storage hiện tại chứa user data
  const currentStorage = localStorage.getItem("user")
    ? localStorage
    : sessionStorage;

  // Cập nhật user data trong storage hiện tại
  currentStorage.setItem("user", JSON.stringify(userData));

  // Fire storage event để đồng bộ với các component khác
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: "user",
      newValue: JSON.stringify(userData),
      storageArea: currentStorage,
    })
  );
};
